import Vue from "vue";
import Vuex from "vuex";

import report from "./report.module";
import complianceLimits from "./complianceLimits.module";
import calculators from "./calculators.module";
import planProvision from "./planProvision.module";
import participants from "./participants.module";
import errors from "./errors.module";
import steps from "./steps.module";
import alternativeDesigns from "./alternativeDesigns.module";
import editAlternativeDesign from "./editAltertiveDesign.module";
import articles from "./articles.module";
import flashMessage from "./flashMessage";
import planDesignFields from "./planDesignFields";
import auth from "./auth.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    report,
    planProvision,
    errors,
    participants,
    complianceLimits,
    calculators,
    steps,
    alternativeDesigns,
    editAlternativeDesign,
    articles,
    flashMessage,
    planDesignFields,
    auth
  }
});
